export const COMPANY_LOGOS = [
  { name: 'Amazon', src: 'assets/img/companies/amazon.png' },
  { name: 'Apple', src: 'assets/img/companies/apple.png' },
  { name: 'Google', src: 'assets/img/companies/google.png' },
  { name: 'Microsoft', src: 'assets/img/companies/microsoft.png' },
  { name: 'Meta', src: 'assets/img/companies/meta.png' },
  { name: 'Stripe', src: 'assets/img/companies/stripe.png' },
  { name: 'Jane Street', src: 'assets/img/companies/janestreet.png' },
  { name: 'Blackstone', src: 'assets/img/companies/blackstone.png' },
  { name: 'JPMorgan', src: 'assets/img/companies/jpmorgan.png' },
  { name: 'DoorDash', src: 'assets/img/companies/doordash.png' },
  { name: 'Tesla', src: 'assets/img/companies/tesla.png' },
  { name: 'PwC', src: 'assets/img/companies/pwc.png' },
  { name: 'Becker', src: 'assets/img/companies/becker.png' },
  { name: 'Nextdoor', src: 'assets/img/companies/nextdoor.png' },
  { name: 'Dell', src: 'assets/img/companies/dell.png' },
  { name: 'Verizon', src: 'assets/img/companies/verizon.png' },
  { name: 'Johnson & Johnson', src: 'assets/img/companies/jnj.png' },
  { name: 'Credit Suisse', src: 'assets/img/companies/creditsuisse.png' },
  { name: 'Code Your Dreams', src: 'assets/img/companies/codeyourdreams.png' },
  { name: 'CompileHer', src: 'assets/img/companies/compileher.png' },
  { name: 'JusticeText', src: 'assets/img/companies/justicetext.png' },
  { name: 'We All Code', src: 'assets/img/companies/weallcode.png' },
] as const;
